class EbooksNormalizer {
  constructor(rawResults) {
    this.data = rawResults.data;
  }

  normalizedData() {
    try {
      if (!this.data.search) {
        throw new Error('[ERROR] API issue, check search api results back!!!');
      }
    } catch (e) {
      return {error: e};
    }

    let rawResults = this.data.search;
    let searchResults = {
      totalResults: rawResults.count,
      offset: rawResults.offset,
      resultCards: [],
    };
    if (searchResults.totalResults === 0) {
      return searchResults;
    }
    searchResults.resultCards = rawResults.hits.map((rawResult) => {
      let card = {};
      let result = rawResult.doc;
      const price = parseFloat(result.metaFields.price);
      const sku = parseInt(result.metaFields.sku);
      card.title = result.metaFields.bookTitle || '';
      card.image = result.metaFields.image || '';
      card.authors = result.metaFields.authors || '';
      card.url = result.url || '';
      card.shortDescription = result.description || '';
      card.longDescription = result.metaFields.bookLongDescription || '';
      card.publishDate = result.metaFields.publishDate || '';
      card.eisbn = result.metaFields.eisbn || '';
      card.pageCount = result.metaFields.pageCount || '';
      card.price = isNaN(price) ? null : price;
      card.sku = isNaN(sku) ? null : sku;
      return card;
    });
    return searchResults;
  }
}

export default EbooksNormalizer;
